import { createContext, useContext } from "react"

export const NavigationContext = createContext()
NavigationContext.displayName = "NavigationContext"

export function NavigationProvider({ children, ...newContext }) {
  const currentContext = useContext(NavigationContext)

  return (
    <NavigationContext.Provider value={{ ...currentContext, ...newContext }}>
      {children}
    </NavigationContext.Provider>
  )
}
